import { z } from 'zod';

import { requiredArray, requiredString } from '@/shared/utils/validation';

export const deviceSchema = z.object({
  name: requiredString(),
  deviceId: requiredString(),
  objectVersion: z.number(),
});

export const addDeviceInputSchema = z.object({
  devices: requiredArray(deviceSchema),
});
